<div class="container" style="width: 100%">
  <div class="header">
    <div class="title">{{ title }}</div>
    <div (click)="close(null)" class="close-btn" *ngIf="type === 'close'">
      <mat-icon class="icon">close</mat-icon>
    </div>
  </div>
  <div class="description" [innerHtml]="description"></div>
  <div class="mg-t-15" *ngIf="closeDelete">
    <mat-radio-group
      [(ngModel)]="selectedChoice"
      (ngModelChange)="onChoiceChange($event)"
      [ngModelOptions]="{ standalone: true }"
      class="presence-radio-group"
    >
      <mat-radio-button class="radio-button" [value]="'close'">
        Fermer les {{ hospitalNames.surgeonOpeningsName.toLowerCase() + 's' }} avec motif
      </mat-radio-button>
      <mat-radio-button class="radio-button" [value]="'delete'">
        Supprimer définitivement les {{ hospitalNames.surgeonOpeningsName.toLowerCase() + 's' }}
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <div
    class="default-select"
    fxLayout="column"
    fxLayoutGap="20px"
    fxLayoutAlign="start stretch"
    *ngIf="motifs && showMotifs"
  >
    <div fxLayout="column" fxLayoutGap="20px" fxLayoutAlign="start stretch">
      <div class="select-label">Motif de fermeture</div>

      <!-- Toggle -->
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="0.5rem" fxFlex="100%">
        <mat-slide-toggle (click)="toggleCanTypeMotif()" [checked]="canTypeMotif"></mat-slide-toggle>
        <div (click)="toggleCanTypeMotif()">Saisir le motif</div>
      </div>
      <!-- End toggle -->

      <!-- Text input or options -->
      @if (canTypeMotif) {
        <app-text-input [inputModel]="selectedMotif" (inputModelChange)="selectedMotifChange($event)"></app-text-input>
      } @else {
        <div class="select-container inputs-width">
          <select [(ngModel)]="selectedMotif" [ngModelOptions]="{ standalone: true }">
            <option [ngValue]="''">--------</option>
            <option *ngFor="let motif of motifs" [ngValue]="motif.name">
              {{ motif.name }}
            </option>
          </select>
        </div>
      }
    </div>
  </div>
  <div *ngIf="type !== 'close'" fxLayout="row" fxLayoutAlign="end center" class="action">
    <app-button
      class="mg-l-8"
      *ngFor="let btn of buttons"
      (click)="close(btn.value)"
      [btnType]="btn.type"
      [text]="btn.name"
      [color]="btn.color"
    ></app-button>
  </div>
</div>
